import ReservationAddDialog from '@/components/restaurant/reservations/ReservationAddDialog.vue'

export default {
  components: {
    ReservationAddDialog
  },

  mixins: [],

  data() {
    return {
      reservationAddDialogVisible: false,
      reservationTableArea       : null,
      reservationCustomer        : null,
      reservationCallerID        : null,
      reservationTable           : null,
      reservationToEdit          : null
    }
  },

  computed: {},

  created() {
    this.$bus.$on('show-table-reservation-dialog', this.showTableReservationDialog)
  },

  beforeDestroy() {
    this.$bus.$off('show-table-reservation-dialog', this.showTableReservationDialog)
  },

  methods: {
    showTableReservationDialog(data) {
      this.reservationTable = data?.Table || null
      this.reservationTableArea = data?.Area || null
      this.reservationCustomer = data?.Customer || null
      this.reservationCallerID = data?.CallerID || null
      this.reservationToEdit = data?.Reservation || null
      this.reservationAddDialogVisible = true
    }
  }
}
